import classNames from 'classnames/bind';
import useTranslation from 'next-translate/useTranslation';
import styles from './JobNotice.module.css';

const cx = classNames.bind(styles);

function JobNotice() {
  const { t } = useTranslation('recruit-jobs');

  return (
    <section className={cx('notice')}>
      <strong className={cx('title')}>{t('notice-title')}</strong>
      <ul className={cx('items')}>
        {t<string[]>('notice-items', null, { returnObjects: true }).map(
          (item) => (
            <li key={item}>{item}</li>
          )
        )}
      </ul>
    </section>
  );
}

export default JobNotice;
